"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_raffles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "90c00f86-2bff-47d7-aaf4-275c9a2f0ff7",
    "data-name": "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "raffles-mid"), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    transform: "translate(192 192) rotate(-180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,91.68s69.6,8.48,41.75,74.09",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,83.07l-16-9A45.27,45.27,0,0,1,55.34,62C49,52.89,48,43.92,52.7,36.71c3-4.63,7.87-6,12.88-4.49a6,6,0,0,0,7.33-3.4c2-4.83,6.22-7.62,11.73-7,8.58,1,14.81,7.57,17.72,18.27a45.23,45.23,0,0,1,1,17.57l-3.41,18",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6e6a69",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,91.68,126,95.07a45.3,45.3,0,0,0,17.62-1c10.73-2.9,17.3-9.12,18.32-17.67.66-5.49-2.13-9.67-7-11.69a6,6,0,0,1-3.42-7.3c1.56-5,.14-9.82-4.5-12.85-7.23-4.71-16.23-3.69-25.35,2.64A45.22,45.22,0,0,0,109.6,59.94l-9,16",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6e6a69",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,83.07,66.12,79.68a45.29,45.29,0,0,0-17.62,1c-10.73,2.9-17.3,9.12-18.32,17.67-.66,5.49,2.13,9.67,7,11.69a6,6,0,0,1,3.42,7.3c-1.56,5-.14,9.82,4.5,12.85,7.23,4.71,16.23,3.69,25.35-2.64a45.22,45.22,0,0,0,12.14-12.78l9-16",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6e6a69",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.15,99l-3.4,18a45.23,45.23,0,0,0,1,17.57c2.91,10.7,9.14,17.24,17.72,18.27,5.51.66,9.7-2.13,11.73-7a6,6,0,0,1,7.33-3.4c5,1.55,9.85.14,12.88-4.49,4.73-7.21,3.71-16.18-2.64-25.27A45.27,45.27,0,0,0,124,100.67l-16-9",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6e6a69",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_raffles;
exports.default = _default;